const getDateFromIso = iso => iso && new Date(iso).toLocaleDateString('pl-PL')

export default getDateFromIso
